export default __webpack_public_path__ + "static/usability-35d415831faa8e5c9836fe7eb30e6694.mp4";